import { DeleteFilled } from '@ant-design/icons';
import { Form, Input, message, notification } from 'antd';
import sha256 from 'crypto-js/sha256';
import Cookies from 'js-cookie';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { AUTH_TOKEN } from '@/api/constants';
import { ROUTES } from '@/lib/routes';
import { Button } from '@/shared/MiButton/MiButton';
import { Tooltip } from '@/shared/MiTooltip/MiTooltip';
import { handleResetCookie } from '@/utils';
import { useSelector } from 'react-redux';
import { ClosedEye, Locked, OpenedEye, Person, Success } from './icons';

const WindowsIcon = props => {
    return (
        <svg width={33} height={32} fill="none" xmlns="http://www.w3.org/2000/svg" className="order-last" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.5 9h-7v6h7V9Zm0 7h-7v6h7v-6Zm1 0h7v6h-7v-6Zm7-7h-7v6h7V9Z"
                fill="#fff"
            />
        </svg>
    );
};

const Login = ({
    isLoggedIn,
    isSessionExpired,
    isLoggedOut,
    JWTAuth,
    LDAPAuth,
    JWTError,
    LDAPError,
    LDAPErrorMessage,
    JWTLoading,
    LDAPLoading,
    setLoggedOut,
}) => {
    const [inputType, setInputType] = useState('password');
    const [visiblePass, setVisiblePass] = useState(false);

    const [login, setlogin] = useState('');
    const [pass, setPass] = useState('');

    const router = useRouter();
    const [api, contextHolder] = notification.useNotification();
useEffect(() => {
    const isAuth = Cookies.get(AUTH_TOKEN);

    if (isAuth) {
        router.replace(ROUTES.HOME);
        if (isLoggedOut) setLoggedOut(false);
    }
}, [router, isLoggedOut, setLoggedOut]);

    useEffect(() => {
        const shouldShowMessage = localStorage.getItem('showResetMessage');
        if (shouldShowMessage) {
            message.success('Данные очищены.', 2);
            localStorage.removeItem('showResetMessage');
        }
    }, []);

useEffect(() => {
    if (!isLoggedOut && isSessionExpired)
        api.info({
            message: `Системное сообщение`,
            description:
                'Вы были перенаправлены на страницу входа в систему, так как время Вашей сессии закончилось.',
            duration: 0,
            placement: 'top',
        });
}, [isSessionExpired, isLoggedOut, api]);

    const loginInputSuffix = () => {
        // return /\S+@\S+\.\S+/.test(login) && login.length > 0 ? <Success /> : null;
        return login.length > 0 ? <Success /> : null;
    };

    const handleLoginChange = event => {
        event.stopPropagation();
        setlogin(event.target.value);
    };

    const handlePassChange = event => {
        event.stopPropagation();
        setPass(event.target.value);
    };

    const handleInputClick = event => {
        if (event.target.nodeName === 'svg' || event.target.nodeName === 'circle') {
            setVisiblePass(!visiblePass);
            return inputType === 'password' ? setInputType('text') : setInputType('password');
        }
        return false;
    };

    // Заглушка
    const showMessage = () => {
        // eslint-disable-next-line no-alert
        alert('Обратитесь к администратору!');
    };

    const showPassInputIcons = () => {
        if (visiblePass) {
            if (pass.length > 0) {
                return (
                    <>
                        <OpenedEye /> <Success className="ml-2" />
                    </>
                );
            }
            return <OpenedEye />;
        }
        if (pass.length > 0) {
            return (
                <>
                    <ClosedEye /> <Success className="ml-2" />
                </>
            );
        }
        return <ClosedEye />;
    };

    const onFinish = values => {
        const { login: username, password } = values;
        // TODO: Хеширование временно отключено для доступа к Active Directory с сырым паролем.
        // const hashDigest = sha256(password).toString();

        // TODO: refactor this! Fast patch!
        JWTAuth({
            username,
            password,
            redirect: () => router.replace(ROUTES.HOME),
        });
    };

    return (
        <div className="flex h-full w-full flex-col items-center justify-center">
            {contextHolder}
            <div className="mb-4 w-3/12 min-w-[440px] rounded bg-white px-8 pb-8 pt-10 text-center dark:bg-block-secondary">
                <div className="mb-2 text-xs uppercase text-font-secondary">Добро пожаловать!</div>
                <div className="mb-16 text-xl font-semibold text-block-secondary dark:text-block-extralight">
                    Вход в систему
                </div>
                <Form
                    className="flex flex-col"
                    name="authForm"
                    initialValues={{
                        remember: true,
                    }}
                    onFinish={onFinish}
                >
                    <div className="mb-8">
                        <Button
                            type="primary"
                            className="flex items-center justify-center"
                            icon={<WindowsIcon />}
                            // TODO: refactor this! Fast patch!
                            onClick={() => LDAPAuth(() => router.replace(ROUTES.HOME))}
                            htmlType="button"
                            loading={LDAPLoading}
                            disabled={LDAPLoading}
                            block
                        >
                            Войти с помощью корпоративной учетной записи
                        </Button>
                    </div>

                    <div className="relative mb-8">
                        <div className="absolute inset-0 flex items-center" aria-hidden>
                            <div className="w-full border-t border-gray-500 dark:border-fill-primary" />
                        </div>
                        <div className="relative flex justify-center text-sm">
                            <span className="bg-white px-2 text-black dark:bg-block-secondary dark:text-block-extralight">
                                или
                            </span>
                        </div>
                    </div>

                    <Form.Item
                        className="mb-8 rounded text-left"
                        name="login"
                        rules={[
                            {
                                required: true,
                                message: 'Обязательное поле',
                            },
                            // {
                            //     type: 'email',
                            //     message: 'Некорректный формат почты',
                            // },
                        ]}
                    >
                        <Input
                            className="rounded"
                            onChange={handleLoginChange}
                            placeholder="Введите логин"
                            prefix={<Person />}
                            suffix={loginInputSuffix()}
                        />
                    </Form.Item>

                    <Form.Item
                        className="mb-12 rounded text-left"
                        name="password"
                        rules={[
                            {
                                required: true,
                                message: 'Обязательное поле',
                            },
                        ]}
                        onClick={handleInputClick}
                    >
                        <Input
                            type={inputType}
                            onChange={handlePassChange}
                            className="rounded"
                            placeholder="Введите пароль"
                            prefix={<Locked />}
                            suffix={showPassInputIcons()}
                        />
                    </Form.Item>

                    {/* Hidden until clarification circumstances. */}
                    {/* <Form.Item name="remember" valuePropName="checked" className="mb-8 text-left">
                        <Checkbox className="text-font-tertiary">Запомнить меня</Checkbox>
                    </Form.Item> */}

                    <Form.Item className="mb-14 min-w-[68px] self-end rounded">
                        <Button type="primary" htmlType="submit" loading={JWTLoading} disabled={JWTLoading} block>
                            Войти
                        </Button>
                    </Form.Item>

                    {JWTError && <div className="mb-8 text-mistake">Неправильный логин или пароль</div>}
                    {LDAPError && (
                        <div className="mb-8 text-mistake">
                            Не удалось войти используя
                            <br></br>
                            учетные данные Windows
                        </div>
                    )}
                    {LDAPErrorMessage && <div className="mb-8 text-mistake">{LDAPErrorMessage}</div>}
                </Form>
                <Tooltip placement="top" title="Если не получается авторизоваться">
                    <Button type="text" className="text-xs" onClick={handleResetCookie}>
                        <DeleteFilled />
                        <span>Сбросить данные</span>
                    </Button>
                </Tooltip>

                <Button type="text" className="text-xs" onClick={showMessage}>
                    Забыли пароль или логин?
                </Button>
            </div>
        </div>
    );
};

export default Login;
